import template from './entityDetailsPreview.html';
import EntityDetailsPreviewCtrl from './entityDetailsPreviewCtrl';

export default {
  template,
  controller: EntityDetailsPreviewCtrl,
  controllerAs: 'vm',
};
